<template>
  <div class="row mb_20">
    <div class="col_12 mb_10">
      <div class="d_flex_btwn " style="border-bottom: 1px solid  rgb(211, 208, 208)">
        <h2>Schedule Calender</h2>
      </div>
    </div>
    <div class="col_2"></div>
    <div class="col_8">
      <div id="calendar" ref="calendar"></div>
    </div>
  </div>

  <modal-component
      v-if="showModal"
      :modal-size="'modal_700p'"
      :header-classes="'display_table white_bg no_border pa15 pb_0'"
      :content-classes="'pl_15 pr_15'"
      @closeModal="closeModal"
  >
    <template #header>
      <span class="modal_header_title">Add Event</span>
    </template>
    <template #content>
      <div class="row mb_10" v-if="currentDateEvents.length">
        <div class="col_4" v-for="row in currentDateEvents" :key="'row'+row.id">
          <label class="edititem font_12p"><p class="m_0 p_0 font_12p">{{row.name}}</p> <span class="color_blue cursor_pointer ml_5" @click.prevent="editItem(row)">Edit</span> <span class="color_danger cursor_pointer ml_5" @click.prevent="deleteItem(row)">Delete</span></label>
        </div>
      </div>
      <div class="row">
        <div class="col_12">
          <div :class="['form-group', {'has_error': errorFor('name')}]">
            <label>Name</label>
            <input type="text" class="form_global" placeholder="Name" v-model="form.name">
            <template v-if="errors && errors.name">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
        </div>
        <div class="col_12">
          <div :class="['form-group', {'has_error': errorFor('description')}]">
            <label>Description</label>
            <textarea name="" id="" cols="30" rows="5" class="form_global" v-model="form.description"></textarea>
          </div>
        </div>
        <div class="col_4">
          <div :class="['form-group']">
            <label>Event Start Time  </label>
            <span>{{form.start_date}}</span>
          </div>
        </div>
        <div class="col_4">
          <div :class="['form-group']">
            <label>Event Start Time H</label>
            <select  class="form_global" v-model="form.start_time_h">
              <option v-for="h in hours" :value="h" :key="'h'+h">{{ h }}</option>
            </select>
          </div>
        </div>
        <div class="col_4">
          <div :class="['form-group']">
            <label>Event Start Time M</label>
            <select  class="form_global" v-model="form.start_time_m">
              <option v-for="m in minutes" :value="m" :key="'m'+m">{{ m }}</option>
            </select>
          </div>
        </div>

        <div class="col_4">
          <div :class="['form-group', {'has_error': errorFor('end_date')}]">
            <label>Event End Date</label>
            <input type="date" class="form_global" placeholder="Name Korean" v-model="form.end_date">
          </div>
        </div>


        <div class="col_4">
          <div :class="['form-group']">
            <label>Event End Time H</label>
            <select  class="form_global" v-model="form.end_time_h">
              <option v-for="h in hours" :value="h" :key="'h'+h">{{ h }}</option>
            </select>
          </div>
        </div>
        <div class="col_4">
          <div :class="['form-group']">
            <label>Event End Time M</label>
            <select  class="form_global" v-model="form.end_time_m">
              <option v-for="m in minutes" :value="m" :key="'m'+m">{{ m }}</option>
            </select>
          </div>
        </div>
        <div class="col_12">
          <div class="d_flex_end">
            <button class="btn btn_common" @click.prevent="submitForm">save <i v-if="loading" class="fas fa-circle-notch fa-spin ml_5"></i></button>
          </div>
        </div>
      </div>
    </template>
  </modal-component>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import ModalComponent from "./shared/ModalComponent";
export default {
  name: "SchedulerCaldander",
  components: {ModalComponent},
  data(){
    return {
      showModal: false,
      showCalendar: true,
      form:{
        name: '',
        description: '',
        start_date: 0,
        start_time_h: 1,
        start_time_m: 0,
        end_date: null,
        end_time_h: 1,
        end_time_m: 0,
        page: null,
      },
      edit: false,
      hours: [],
      minutes: [],
      datasets: [],
      events: [],
      initCalender: null,
      currentDateEvents: []
    }
  },
  created() {
    this.loadContent()
  },
  mounted() {
    for (let i = 1; i <= 24; i++)
      this.hours.push(i)

    for (let i = 0; i <= 60; i++)
      this.minutes.push(i)
  },
  methods: {
    loadContent(){
      this.events = [];
      this.axios.get('/schdule-calender/'+this.$route.params.id)
          .then((response) => {
            this.datasets = response.data.data;
            if(this.datasets.length){
              this.datasets.map((row)=>{
                 let tempRow = {
                   title: row.name,
                   start: row.start_format_date,
                   end: row.end_format_date,
                   color: '#2c3e50',
                   textColor: 'white',
                 }
                this.events.push(tempRow)
              })
            }
            this.calanderRender();
          })
    },
    calanderRender(){
      const calendarEl = document.getElementById('calendar')

      if(calendarEl) {
        this.initCalender = new Calendar(calendarEl, {
          plugins: [
            interactionPlugin,
            dayGridPlugin,
            timeGridPlugin
          ],
          initialView: 'dayGridMonth',
          editable: true,
          dateClick: this.handleDateClick,
          events: [...this.events]
        })

        setTimeout(() => {
          this.initCalender.render()
        }, 100)
      }
    },
    handleDateClick(info) {
      this.resetForm()
      this.currentDateEvents = this.datasets.filter((item) => item.start_date === info.dateStr || item.end_date === info.dateStr)
      this.form.start_date = info.dateStr
      this.form.page = +this.$route.params.id
      this.showModal = true
    },
    closeModal(){
      this.showModal = false
    },
    submitForm(){
      this.errors = null;
      this.loading = true;

      this.axios.post('/schdule-calender', this.form)
          .then(() => {
            this.showModal = false;
            this.showSuccessMsg("Added Successfully!");
              this.initCalender.destroy()
              this.loadContent()
          })
          .catch((err) => {
            this.errors = err.response.data.errors
          })
          .finally(() => {
            this.loading = false;
          })
    },
    resetForm(){
      this.form = {
        name: '',
        description: '',
        start_date: 0,
        start_time_h: 1,
        start_time_m: 0,
        end_date: null,
        end_time_h: 1,
        end_time_m: 0,
        page: null,
      }
    },
    editItem(row){
      this.form = row
    },
    deleteItem(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/schdule-calender/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Page has been deleted!',
                'success'
            )
            this.initCalender.destroy()
            this.loadContent()
          });
        }
      });
    },

  },
}
</script>
<style scoped>
label.edititem{
  border: 1px solid rgb(211, 208, 208);
  padding: 5px 10px;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
label.edititem p{
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>